import { FC } from 'lib/component-utils'
import { useUserContext } from 'lib/context'
import { storage } from 'lib/local-storage'
import { useEffect } from 'react'
import { useState } from 'react'

const CookieConsent: FC = () => {
  const ctx = useUserContext()
  const [show, setShow] = useState(false)

  useEffect(() => {
    setShow(
      ['sellmonitor', 'sellematics'].includes(ctx.theme.hostType) &&
        !storage.get('cookieConsent:accepted')
    )
  }, [])

  if (!show) return null

  return (
    <div className="pointer-events-none fixed inset-x-0 bottom-0 px-4 sm:px-6 pb-24 sm:pb-16 z-[50]">
      <div className="pointer-events-auto ml-auto text-balance max-w-[480px] rounded-xl bg-white px-5 py-3 shadow-lg ring-1 ring-gray-900/10 flex items-center gap-8">
        <p className="text-sm/[1.35rem] text-gray-900">
          Пользуясь сайтом, вы принимаете{' '}
          <a
            target="_blank"
            rel="noreferrer"
            href="/cookies/"
            className="font-medium text-primary-600"
          >
            политику куки
          </a>
        </p>
        <div className="flex items-center gap-x-5">
          <button
            type="button"
            className="rounded-md bg-primary-600 px-3 py-2 text-sm font-medium text-white shadow-xs hover:bg-primary-700 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary-600"
            onClick={() => {
              storage.set('cookieConsent:accepted', true)
              setShow(false)
            }}
          >
            Хорошо
          </button>
        </div>
      </div>
    </div>
  )
}

export default CookieConsent
